module.exports = __webpack_public_path__ + "media/images/div_lens/footer-img-185a70b3dc9647cbc84624b9376ef22f.jpg";